function formatDate(ts) {
  return new Date(ts).toLocaleDateString(undefined, {
    month: 'short', day: 'numeric', year: 'numeric'
  });
}

export default function History({ items }) {
  if (items.length === 0) {
    return (
      <div className="empty-state">
        <div className="empty-icon">📋</div>
        <h2>No decisions yet</h2>
        <p>Your past decisions will show up here once you act on items from the wishlist.</p>
      </div>
    );
  }

  const sorted = [...items].sort((a, b) => b.decidedAt - a.decidedAt);

  return (
    <div className="history">
      <div className="history-header">
        <h2 className="history-title">The Archive</h2>
        <p className="history-sub">Every dismissed item is a victory for your future self.</p>
      </div>
      <div className="history-list">
        {sorted.map(item => (
          <div key={item.id} className={`history-item history-item--${item.status}`}>
            <div className="history-icon">
              {item.status === 'skipped' ? '💚' : '🛍️'}
            </div>
            <div className="history-info">
              <a
                href={item.url}
                target="_blank"
                rel="noopener noreferrer"
                className="history-name"
              >
                {item.name}
              </a>
              <span className="history-date">{formatDate(item.decidedAt)}</span>
            </div>
            <div className="history-right">
              {item.price && (
                <span className={`history-price history-price--${item.status}`}>
                  {item.status === 'skipped' ? '+' : '-'}${item.price.toFixed(2)}
                </span>
              )}
              <span className={`history-badge history-badge--${item.status}`}>
                {item.status === 'skipped' ? 'Skipped' : 'Bought'}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
